<div
  *ngIf="buttonStyle === undefined; else buttonWithStyle"
  (click)="emitAction()"
  [ngClass]="{
    'mu-button-extra-active': flagList?.get(activeFlag)
  }"
  class="mu-button-extra-{{ skin }}"
>
  <i class="fas {{ icon }} mu-icon {{ icon }}" aria-hidden="true"></i>
  <div class="mu-action-add-label">
    {{ 'form.button.' + (flagList?.get(activeFlag) && activeLabel ? activeLabel : label) | translate }}
  </div>
</div>
<ng-template #buttonWithStyle>
  <p-button
    type="button"
    class="mu-button mu-button-full-width mu-add-button-styled {{ buttonStyle }}"
    icon="fas {{ icon }}"
    iconPos="left"
    label="{{ 'form.button.' + (flagList?.get(activeFlag) && activeLabel ? activeLabel : label) | translate }}"
    (onClick)="emitAction()"
    [disabled]="!hasPermission"
  >
  </p-button>
</ng-template>
